import { BrowserRouter } from "react-router-dom";
import React from "react";
import { hydrate } from "react-dom";
import App from "../common/App";

const cookies = document.cookie;
// console.log("CLIENT :: cookies :: ", cookies)
hydrate(
  <BrowserRouter>
    <App cookies={{ ...cookies }} />
  </BrowserRouter>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", () => {
//     navigator.serviceWorker.register("/assets/sw.js").then(
//       registration => {
//         // Registration was successful
//         console.log(
//           "ServiceWorker registration successful with scope: ",
//           registration.scope
//         );
//       },
//       err => {
//         // registration failed :(
//         console.log("ServiceWorker registration failed: ", err);
//       }
//     );
//   });
// }
